import React, {useEffect, useState} from 'react';
import { Input, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { ErrorMessage } from 'formik';
import { injectIntl } from 'react-intl';
import { SelectField } from "../../../../shared/SelectField";
import {
  COUPON_TYPE,
  DISCOUNT_TYPE,
  PERCENT
} from "../../../../../config/constants/Campaign/campaign_constants";
import { FieldMessages } from "../../../../layout/Messages/FieldMessages";
import { NOTIFICATION_CREATE_COUPON } from "../../../../../config/notifications";
import { AddProductItem } from "./actions/AddProductItem";
import { RemoveProductItem } from "./actions/RemoveProductItem";
import {
  getErrorClassCouponProducts,
  getProductName,
  getItemPrice,
  getItemCurrency,
  getFinalPrice,
} from "../../../../../helpers/campaign_coupon";
import { FormattedMessage } from 'react-intl';

function TableRowComponent(props) {
  const {
    formikProps,
    productGroups,
    lang,
    index,
    maxProds,
    addedProdNums,
    removeRow,
    setAddRow,
  } = props;

  const [ discountValue, setDiscountValue ] = useState({});
  const [ discountType, setDiscountType ] = useState(PERCENT);
  const [ optionsProductGroups, setOptionsProductGroups ] = useState({});
  const [ optionsProducts, setOptionsProducts ] = useState([]);

  const defaultOption = {
    value: '',
    label: <FormattedMessage id="components.pages.campaignManagement.editCampaign.productTable.tableRow.defaultOption" />,
  };

  const [ currentProductGroup, setCurrentProductGroup ] = useState(defaultOption);
  const [ currentProduct, setCurrentProduct ] = useState(defaultOption);

  useEffect(() => {
    productGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ productGroups ]);

  const productGroup = () => {
    let localOptionsProducts = [];
    let localOptionsProductGroups = {};

    if (!productGroups || !productGroups.length) {
      return;
    }

    productGroups.forEach((product) => {
      if (!localOptionsProducts.length) {
        localOptionsProducts.push(defaultOption);
      }

      localOptionsProducts.push({
        value: product.id,
        label: getProductName(product.translations, lang),
      });

      if (
        formikProps && formikProps.values && formikProps.values.coupon_products
        && formikProps.values.coupon_products[index] && formikProps.values.coupon_products[index].product_group_id
        && formikProps.values.coupon_products[index].product_group_id === product.id
      ) {
        setCurrentProductGroup({
          value: formikProps.values.coupon_products[index].product_group_id,
          label: getProductName(product.translations, lang),
        });
      }

      localOptionsProductGroups[product.id] = [];

      product.products.forEach((productGroup) => {
        if (productGroup.name !== "custom-order") {
          if (!localOptionsProductGroups[product.id].length) {
            localOptionsProductGroups[product.id].push(defaultOption);
          }

          localOptionsProductGroups[product.id].push({
            value: productGroup.id,
            label: getProductName(productGroup.translations, lang),
          });

          if (
            formikProps && formikProps.values && formikProps.values.coupon_products
            && formikProps.values.coupon_products[index] && formikProps.values.coupon_products[index].product_id
            && formikProps.values.coupon_products[index].product_id === productGroup.id
          ) {
            setCurrentProduct({
              value: formikProps.values.coupon_products[index].product_id,
              label: getProductName(productGroup.translations, lang),
            });
          }
        }
      });
    });

    setOptionsProductGroups({
      ...localOptionsProductGroups
    });
    setOptionsProducts([
      ...localOptionsProducts
    ]);
  }

  return (
    <>
    <tr key={ currentProduct }>
      <td className="align-middle text-wrap">
        <SelectField
          name="product_group_id"
          classNamePrefix="ml-0"
          value={ currentProductGroup }
          defaultValue={ currentProductGroup }
          options={ optionsProducts }
          placement="top"
          menuPortalTarget={ document.body }
          menuPosition="fixed"
          onChange={
            option => {
              formikProps.setFieldValue(`coupon_products[${index}].product_group_id`, option.value);
              formikProps.setFieldValue(`coupon_products[${index}].product_id`, defaultOption.value);
              setCurrentProductGroup(option);
              setCurrentProduct(defaultOption);
            }
          }
          formikProps={ formikProps }
        />
      </td>
      <td className="align-middle text-wrap">
        <SelectField
          name={ `coupon_products[${index}].product_id` }
          classNamePrefix="ml-0"
          value={ currentProduct }
          defaultValue={ currentProduct ?? defaultOption }
          options={ optionsProductGroups[currentProductGroup.value] ?? [defaultOption] }
          placement="top"
          menuPortalTarget={ document.body }
          menuPosition="fixed"
          onChange={
            option => {
              formikProps.setFieldValue(`coupon_products[${index}].product_id`, option.value);
              setCurrentProduct(option);
            }
          }
          formikProps={ formikProps }
        />
      </td>
      <td className="align-middle text-wrap">{ getItemPrice(productGroups, currentProduct.value, currentProductGroup.value) } { getItemCurrency(productGroups, currentProduct.value, currentProductGroup.value) }</td>
      <td className="align-middle text-wrap">
        <SelectField
          name={ `coupon_products[${index}].discount_type` }
          classNamePrefix="ml-0"
          defaultValue={ DISCOUNT_TYPE[0] }
          options={ DISCOUNT_TYPE }
          isDisabled={ DISCOUNT_TYPE.length === 1 }
          onChange={
            value => {
              formikProps.setFieldValue(`coupon_products[${index}].discount_type`, value.value);
              setDiscountType(value.value);
            }
          }
          formikProps={ formikProps }
          getErrorClass={ getErrorClassCouponProducts(formikProps, `coupon_products[${index}].discount_type`) }
        />
      </td>
      <td className="align-middle col-1 text-wrap">
        <Input
          type="text"
          onChange={
            event => {
              setDiscountValue({
                ...discountValue,
                [index]: parseFloat((event.target.value && event.target.value < 100 ? event.target.value : 0))
              });

              formikProps.setFieldValue(`coupon_products[${index}].value`, event.target.value);
            }
          }
          className={ getErrorClassCouponProducts(formikProps, `coupon_products[${index}].value`) }
          value={ (
            formikProps && formikProps.values && formikProps.values.coupon_products
            && formikProps.values.coupon_products[index] && formikProps.values.coupon_products[index].value) || ""
          }
        />
      </td>
      <td className="align-middle text-wrap">
        {
          getFinalPrice(
            getItemPrice(productGroups, currentProduct.value, currentProductGroup.value),
            discountValue,
            discountType,
            index
          )
        } { getItemCurrency(productGroups, currentProduct.value, currentProductGroup.value) }
      </td>
      <td className="align-middle text-wrap">
        {
          COUPON_TYPE && COUPON_TYPE[1] && COUPON_TYPE[1].value && formikProps && formikProps.values && formikProps.values.type !== COUPON_TYPE[1].value ?
          <Row>
            { addedProdNums < maxProds ?
              <AddProductItem
                index={ index }
                setAddRow={ setAddRow }
              /> : null
            }
            { addedProdNums > 1 ?
              <RemoveProductItem
                index={ index }
                removeRow={ removeRow }
              /> : null
            }
          </Row> : null
        }
      </td>
    </tr>
    <tr>
      <td className="text-wrap">
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="product_group_id"
          errorname={ `coupon_products.${index}.product_group_id` }
          notificationId={ NOTIFICATION_CREATE_COUPON }
          addMargin={ true }
        >
          <ErrorMessage
            name={ `coupon_products[${index}].product_group_id` }
            component="div"
            data-testid={ `errors-coupon_products[${index}].product_group_id` }
          />
        </FieldMessages>
      </td>
      <td className="text-wrap">
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="product_id"
          errorname={ `coupon_products.${index}.product_id` }
          notificationId={ NOTIFICATION_CREATE_COUPON }
          addMargin={ true }
        >
          <ErrorMessage
            name={ `coupon_products[${index}].product_id` }
            component="div"
            data-testid={ `errors-coupon_products[${index}].product_id` }
          />
        </FieldMessages>
      </td>
      <td className="text-wrap"></td>
      <td className="text-wrap">
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="discount_type"
          errorname={ `coupon_products.${index}.discount_type` }
          notificationId={ NOTIFICATION_CREATE_COUPON }
          addMargin={ true }
        >
          <ErrorMessage
            name={ `coupon_products[${index}].discount_type` }
            component="div"
            data-testid={ `errors-coupon_products[${index}].discount_type` }
          />
        </FieldMessages>
      </td>
      <td className="text-wrap">
        <FieldMessages
          color="danger"
          formikProps={ formikProps }
          class="small-field-error"
          showDismiss={ false }
          name="value"
          errorname={ `coupon_products.${index}.value` }
          notificationId={ NOTIFICATION_CREATE_COUPON }
        >
          <ErrorMessage
            name={ `coupon_products[${index}].value` }
            component="div"
            data-testid={ `errors-coupon_products[${index}].value` }
          />
        </FieldMessages>
      </td>
    </tr>
    </>
  )
}

const mapStateToProps = state => ({
  lang: state.locale.lang,
});

const TableRow = connect(mapStateToProps, null)(injectIntl(TableRowComponent));

export { TableRow, TableRowComponent }
